<template>
  <h4 class="p-5 2xl:hidden">
    <a href="#" @click="toggleProfile" class="float-right"><XCircleIcon class="h-5 w-5 inline-block" /></a>
    {{ $t('conversation.profile') }}
  </h4>
  <div v-if="customer.attributes.avatar">
    <img v-bind:src="customer.attributes.avatar" v-bind:alt="customer.attributes.name" class="object-cover w-full">
  </div>
  <div v-else class="text-center p-5">
    <img src="@/assets/logo_big.svg" v-bind:alt="customer.attributes.name" class="max-h-80 inline-block">
  </div>
  <div class="p-5 pb-1">
    <h4 class="font-bold mb-2">{{ customer.attributes.name }}</h4>
    <div class="sm:col-span-1 mb-5" v-if="customer.attributes['phone-number']">
      <dt class="text-sm font-medium text-gray-500">
        {{ $t('customers.phone') }}
      </dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ customer.attributes['phone-number'] }}
      </dd>
    </div>
    <div class="sm:col-span-1 mb-5" v-if="customer.attributes.email">
      <dt class="text-sm font-medium text-gray-500">
        {{ $t('customers.email') }}
      </dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ customer.attributes.email }}
      </dd>
    </div>
    <div class="sm:col-span-1 mb-5" v-if="customer.attributes.comments">
      <dt class="text-sm font-medium text-gray-500">
        {{ $t('customers.comments') }}
      </dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{ customer.attributes.comments }}
      </dd>
    </div>
  </div>
  <h4 v-if="conversation" class="font-bold mb-1 mt-4 border-t border-gray-300 pl-5 pr-5 pt-5">
    {{ $t('conversation.channels') }}
  </h4>
  <div class="p-5">
    <ul>
      <li class="mb-3" v-for="channel of this.customerChannels" v-bind:key="channel.id">
        <ChannelLabel v-bind:channel="channel" />
      </li>
    </ul>
  </div>
  <div class="pl-5 pr-5 border-t border-gray-300 pt-4">
    <div class="sm:col-span-1 mb-5">
      <dt class="text-sm font-medium text-gray-500">
        {{ $t('conversation.lastUpdate') }}
      </dt>
      <dd class="mt-1 text-sm text-gray-900">
        <Datetime v-bind:date="conversation.last_updated_at" fromNow="True" />
      </dd>
    </div>
    <div class="sm:col-span-1 mb-5">
      <dt class="text-sm font-medium text-gray-500">
        {{ $t('conversation.createdAt') }}
      </dt>
      <dd class="mt-1 text-sm text-gray-900">
        <Datetime v-bind:date="conversation.created_at" />
        (<Datetime v-bind:date="conversation.created_at" fromNow="True" />)
      </dd>
    </div>
    <div class="sm:col-span-1" v-if="lastResolve">
      <dt class="text-sm font-medium text-gray-500">
        <template v-if="conversation.status === 'closed'">{{ $t('conversation.reasonForResolving') }}</template>
        <template v-else>{{ $t('conversation.reasonForLastResolving') }}</template>
      </dt>
      <dd class="mt-1 text-sm text-gray-900">
        {{lastResolve}}
      </dd>
    </div>
  </div>
  <div class="mt-4 pl-4 pr-4 border-t border-gray-300 pt-2">
    <ul role="list" class="divide-y divide-gray-200">
      <li class="py-4" v-for="message of internalNotes" v-bind:key="message.id" >
        <AsideInternalNoteItem :message="message" />
      </li>
    </ul>
  </div>
</template>

<script>
import {
  XCircleIcon,
} from '@heroicons/vue/outline'

import Datetime from '../../building_blocks/DateTime.vue'
import ChannelLabel from '@/components/conversations/parts/ChannelLabel';
import { useReasonForResolvingStore } from "@/stores/reasonForResolving";
import AsideInternalNoteItem from "@/components/conversations/parts/AsideInternalNoteItem";


export default {
  name: 'CustomerProfile',
  props: ['customer', 'conversation', 'messages', 'customerChannels'],
  emits: ['toggle-profile'],
  components: {
    AsideInternalNoteItem,
    Datetime,
    ChannelLabel,
    //
    XCircleIcon,
  },
  setup() {
    let reasonStore = useReasonForResolvingStore();
    return { reasonStore };
  },
  methods: {
    toggleProfile() {
      this.$emit('toggle-profile');
    },
  },
  computed: {
    lastResolve() {
      let resolveMessage = undefined;
      this.messages.forEach(m => {
        if (m.type === 'resolve_message') {
          resolveMessage = m;
        }
      });
      if (resolveMessage) {
        let reason = this.reasonStore.getById(resolveMessage.reason_id);
        if (reason) {
          return reason.attributes.reason;
        }
      }
      return '';
    },
    internalNotes() {
      return this.messages.filter(m => {
        return m.type === 'internal_message';
      });
    }
  },
}
</script>
